import React from 'react';
import './App.css';
import {Table} from 'react-bootstrap';

export class StatDashboard extends React.Component {

    constructor(props){
      super(props);
    }
  
    render() {
      let funds = this.props.funds; 
      let income = this.props.income;
      let salary = this.props.salary;
      let profit = this.props.profit;
      let powerLevel = this.props.powerLevel;
      let nextFinPeriod = this.props.nextFinPeriod;
      let nextTourney = this.props.nextTourney;

      return (
        <Table striped bordered hover size="sm">
            <thead>
            <tr>
                <th> Field </th>
                <th> Value </th> 
            </tr>
            </thead>
            <tbody>
            <tr>
                <td> Current Funds </td> 
                <td> {funds} </td> 
            </tr>
            <tr>
                <td> Income </td> 
                <td> {income} </td> 
            </tr>
            <tr>
                <td> Salary </td> 
                <td> {salary} </td> 
            </tr>
            <tr>
                <td> Profit </td> 
                <td> {profit} </td> 
            </tr>
            <tr>
                <td> Power Level </td> 
                <td> {powerLevel} </td> 
            </tr>
            <tr>
                <td> Next Financial Period </td> 
                <td> {nextFinPeriod} </td> 
            </tr>
            <tr>
                <td> Next Competitive Event </td> 
                <td> {nextTourney} </td> 
            </tr>
            </tbody>
        </Table>
        );
    }
  }
  
export default StatDashboard;